import { SelectOption } from '@/components/form-builder/form-builder.types';
import { createStore, withProps } from '@ngneat/elf';

export interface GroupMemberDto {
  societeId?: number;
  chefDeFile: boolean;
}

export interface BidderDto {
  soumissionId?: number;
  groupSoumissionId?: number;
  societeId?: number;
  typeSoumission: 'INDIVIDUEL' | 'GROUPEMENT';
  status: 'VALIDE' | 'REJETE';
  lotIds?: number[];
  groupSoumissionList: GroupMemberDto[];
}

export interface BidderStateProps {
  dto: BidderDto;
  companySelected?: SelectOption;
  errors: Record<string, any>;
}

export const bidderInitialState: BidderStateProps = {
  dto: {
    societeId: undefined,
    typeSoumission: 'INDIVIDUEL',
    status: 'VALIDE',
    groupSoumissionList: [],
  },
  companySelected: undefined,
  errors: {},
};

export type BidderStore = ReturnType<typeof bidderStoreFactory>;

export const bidderStoreFactory = (id: string) => {
  return createStore(
    { name: `bidder-state-${id}` },
    withProps<BidderStateProps>(structuredClone(bidderInitialState))
  );
};
